import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import Image from "react-bootstrap/Image";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import Container from "react-bootstrap/Container";

import { Animated } from "react-animated-css";
import isNull from "lodash/isNull";
import isEmpty from "lodash/isEmpty";
import { isMobile } from 'react-device-detect';

import * as actionCreators from "../store/actions"
import isStringArabic from '../store/isStringArabic';
import CartMenu from "../components/CartMenu";


// IMAGES
import WhatsApp01 from "../images/svgs/SocialMediaMenu/Whatsapp01.svg";
import Menu from "../images/svgs/SocialMediaMenu/Menu.svg";
import Close01 from "../images/svgs/SocialMediaMenu/Close01.svg";
import Phone01 from "../images/svgs/SocialMediaMenu/Phone01.svg";
import Instagram01 from "../images/svgs/SocialMediaMenu/Instagram01.svg";
import Snapchat01 from "../images/svgs/SocialMediaMenu/Snapchat01.svg";
import Twitter01 from "../images/svgs/SocialMediaMenu/Twitter01.svg";
import Youtube from "../images/svgs/Youtube.svg";
import Location01 from "../images/svgs/SocialMediaMenu/Location01.svg"
import Website from "../images/svgs/website.svg";
import CartIcon from "../images/svgs/cart.svg"
import SuccessPurple from "../images/svgs/SuccessPurple.svg"

class PaymentEnd extends React.Component {
  state = {
    menuExpaned: false,
    bucketExpaned: false
  }
  componentDidMount() {
    // Send transaction data with a pageview if available
    // when the page loads. Otherwise, use an event when the transaction
    // data becomes available.
    window.dataLayer.push({
      'ecommerce': {
        'purchase': {
          // 'actionField': {
          //   // 'id': 'T12345',                         // Transaction ID. Required for purchases and refunds.
          //   // 'affiliation': 'Online Store',
          //   // 'revenue': '35.43',                     // Total transaction value (incl. tax and shipping)
          //   // 'tax':'4.90',
          //   // 'shipping': '5.99',
          //   // 'coupon': 'SUMMER_SALE'
          // },
        'products': this.props.cartList.map(item => {
            return {
            'id': item.id,
            'name': item.name,
            'quantity': item.quantity,
            'price': item.price,
            'unit_price': parseFloat (item.unit_price)
            }
          })
        }
      }
    });
  }
  goBack = () => {
    this.props.history.goBack();
  }
  closeCartMenu = () => {
    this.setState({
      bucketExpaned: false
    })
  }

  render() {
    const { currency } = this.props
    const cartList = [{ "id": "92", "quantity": 4, "name": "Product 13", "unit_price": "400", "price": 1600, "media_url": "https://s3.ap-south-1.amazonaws.com/optimizeapp-ecommerce/media/1597588461.jpg" }, { "id": "86", "quantity": 1, "name": "Shoes black", "unit_price": "3100", "price": 3100, "media_url": "https://s3.ap-south-1.amazonaws.com/optimizeapp-ecommerce/media/1597586603.jpg" }]
    document.body.classList.remove('inner-page');
    const translate = this.props.translate;
    return <div className={"outerDiv paymentOuterDiv"}>
      <div className={`topNavBar ${this.props.language === "ar" && "topNavBarRTL"}`}
        style={{
          filter: window.innerWidth <= 991 && (this.state.menuExpaned || this.state.bucketExpaned) ? "blur(5px)" : "none"
        }}
      >

        <Row className="brandImageRow">
          <Image className="brandImage" src={this.props.instagramAccountInfo.brandProfilePic} onError={this.errorLoadingPicture} />
        </Row>
        <Row
          className="brandNameText"
          style={{
            fontFamily: isStringArabic(this.props.instagramAccountInfo.brandName)
              ? 'Changa-bold'
              : 'Montserrat-bold',
          }}
        >
          {this.props.instagramAccountInfo.brandName}
        </Row>
        {/* <Image className="headLogo" src={"/clientwebsite2/assets/images/LogoPurple.svg"} />

					<p className={`poweredSlideText ${this.props.language === "ar" && "arabic"}`}>
						{translate[`This site is Powered by Optimize App`]}
					</p>
					<a
						href="https://app.adjust.com/fw3cwi8?label=OptimizeShop&redirect=https%3A%2F%2Fwww.optimizeapp.com%2Fdownload"
						target="_blank"
						rel="noopener noreferrer"
						className={`getYoursText ${this.props.language === "ar" && "arabic"}`}>
						{translate[`Get yours now!`]}
					</a> */}
        <p onClick={this.changeLanguage} className={`languageButton ${this.props.language === "en" && "arabic"} ${this.props.language === "ar" && " languageButtonRTL"}`} >
          {this.props.language === "en" ? "العربية" : "English"}
        </p>
      </div>

      <Container className="mainHome">


        <Navbar expand={"lg"} className={"navBarBlock"} onToggle={(expanded) => {
          this.setState({
            menuExpaned: expanded
          })
        }}>
          <div className="innerBlock1">
            <Navbar.Toggle aria-controls="basic-navbar-nav" className={`menuBtn ${!this.state.menuExpaned && "myCartBtn"}`}
              style={this.state.menuExpaned || this.state.bucketExpaned ? {
                position: "absolute",
                top: "-55%",
                zIndex: 20,
                right: "25%",
              } : {
                  marginLeft: 7,
                }}
            >
              <Image
                src={!this.state.menuExpaned ? Menu : Close01}
              />
            </Navbar.Toggle>
            {/* <Row className="brandImageRow">
								<Image className="brandImage" src={this.props.instagramAccountInfo.brandProfilePic} onError={this.errorLoadingPicture} />
							</Row>
							<Row
								className="brandNameText"
								style={{
									fontFamily: isStringArabic(this.props.instagramAccountInfo.brandName)
										? 'Changa-bold'
										: 'Montserrat-bold',
								}}
							>
								{this.props.instagramAccountInfo.brandName}
							</Row> */}
            {
              this.props.instagramAccountInfo.businessName === 'bonabeel' && (
                <Row className="brandNameSubText bonabeelText">مبادر | مسوق | محاور</Row>
              )
            }
            {this.props.instagramAccountInfo.brandName === 'العجمان اليوم' && (
              <Row className="brandNameSubText">تغطيات مميزة . مقاطع حصرية</Row>
            )}



            {this.props.errorMessage && <Row className="errorMessageText">{this.props.errorMessage}</Row>}
          </div>
          {
            this.props.instagramAccountInfo.businessName !== "shaheenmusic" &&

            <Animated animationIn="slideInLeft" animationOut="slideOutLeft" isVisible={this.state.menuExpaned || window.innerWidth >= 1024} className="socialMediaButtons">
              <Navbar.Collapse id="responsive-navbar-nav" className={"navBarCollapse"} >
                {this.state.menuExpaned && <div className="navBarHeader">
                  <Image className="brandImage" src={this.props.instagramAccountInfo.brandProfilePic} onError={this.errorLoadingPicture} />
                  <p style={{
                    fontFamily: isStringArabic(this.props.instagramAccountInfo.brandName)
                      ? 'Changa-bold'
                      : 'Montserrat-bold',
                  }}
                  >
                    {this.props.instagramAccountInfo.brandName}
                  </p>
                </div>}
                {this.props.instagramAccountInfo.youtube_handle && (
                  <Col className="columnDiv">
                    <Nav.Link
                      href={this.props.instagramAccountInfo.youtube_handle}
                      target="_blank"
                      rel="noopener noreferrer"
                      id="youtubelink"
                    >
                      <Image
                        className="socialButtonImages socialButtonLogo"
                        src={Youtube}
                      />
                      {(this.props.instagramAccountInfo.showIconButtonNames || this.state.menuExpaned) &&
                        <p className={`socialMediaName ${this.props.language === "ar" && "arabic"}`}>{translate[this.props.instagramAccountInfo.buttonYoutube]}</p>
                      }
                    </Nav.Link>
                    {/* {this.props.instagramAccountInfo.showIconButtonNames &&
											<p className={`socialMediaName ${this.props.language === "ar" && "arabic"}`}>{translate[this.props.instagramAccountInfo.buttonYoutube]}</p>
										} */}

                  </Col>
                )}
                {this.props.instagramAccountInfo.telephoneNumber && (
                  <Col className="columnDiv">
                    <a
                      href={`tel:${this.props.instagramAccountInfo.telephoneNumber}`}
                      id="telephoneNumber"
                      className={"navLink"}
                    >
                      <Image className="socialButtonImages" src={Phone01} />
                      {(this.props.instagramAccountInfo.showIconButtonNames || this.state.menuExpaned) &&
                        <p className={`socialMediaName ${this.props.language === "ar" && "arabic"}`}>{translate[this.props.instagramAccountInfo.buttonPhone]}</p>
                      }
                    </a>
                    {/* {this.props.instagramAccountInfo.showIconButtonNames &&
											<p className={`socialMediaName ${this.props.language === "ar" && "arabic"}`}>{translate[this.props.instagramAccountInfo.buttonPhone]}</p>
										} */}
                  </Col>
                )}
                {(this.props.instagramAccountInfo.insta_handle && (this.props.pathname === "/" ||
                  this.props.pathname === "/ar" || this.props.pathname === "/instagram" ||
                  this.props.pathname === "/clientwebsite2/ar" || this.props.pathname === "/clientwebsite2/" || this.props.pathname === "/clientwebsite2/ar/")
                )
                  && (
                    <Col className="columnDiv">
                      <Nav.Link
                        href={this.props.instagramAccountInfo.instagramLink}
                        target="_blank"
                        rel="noopener noreferrer"
                        id="instagramLink"
                        onClick={() => {
                          if (
                            !isNull(this.props.instagramAccountInfo.snap_pixel_script) &&
                            !isEmpty(this.props.instagramAccountInfo.snap_pixel_script) &&
                            this.props.instagramAccountInfo.snap_pixel_script) {
                            window.snaptr('track', 'VIEW_CONTENT')
                          }
                          // if (isMobile) {
                          // 	window.open(this.props.instagramAccountInfo.instagramLink)
                          // } else {
                          // 	window.open(`https://www.instagram.com/${this.props.instagramAccountInfo.insta_handle}`)
                          // }

                          return true
                        }}
                        className={"navLink"}
                      >
                        <Image className="socialButtonImages" src={Instagram01} />
                        {(this.props.instagramAccountInfo.showIconButtonNames || this.state.menuExpaned) &&
                          <p className={`socialMediaName ${this.props.language === "ar" && "arabic"}`}>{translate[this.props.instagramAccountInfo.buttonInstagram]}</p>
                        }
                      </Nav.Link>
                      {/* {this.props.instagramAccountInfo.showIconButtonNames &&
												<p className={`socialMediaName ${this.props.language === "ar" && "arabic"}`}>{translate[this.props.instagramAccountInfo.buttonInstagram]}</p>
											} */}
                    </Col>
                  )}
                {(this.props.instagramAccountInfo.snapchat_handle &&
                  (this.props.pathname === "/" || this.props.pathname === "/ar" ||
                    this.props.pathname === "/snap"
                    || this.props.pathname === "/clientwebsite2/ar" || this.props.pathname === "/clientwebsite2/" || this.props.pathname === "/clientwebsite2/ar/")) && (
                    <Col className="columnDiv">
                      <a
                        href={`https://www.snapchat.com/add/${this.props.instagramAccountInfo.snapchat_handle}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        id="snapchatLink"
                        className={"navLink"}
                      >
                        <Image className="socialButtonImages" src={Snapchat01} />
                        {(this.props.instagramAccountInfo.showIconButtonNames || this.state.menuExpaned) &&
                          <p className={`socialMediaName ${this.props.language === "ar" && "arabic"}`}>{translate[this.props.instagramAccountInfo.buttonSnapchat]}</p>
                        }
                      </a>
                      {/* {this.props.instagramAccountInfo.showIconButtonNames &&
											<p className={`socialMediaName ${this.props.language === "ar" && "arabic"}`}>{translate[this.props.instagramAccountInfo.buttonSnapchat]}</p>
										} */}

                    </Col>
                  )}
                {this.props.instagramAccountInfo.twitter_handle && (
                  <Col className="columnDiv">
                    <a
                      href={`https://twitter.com/${this.props.instagramAccountInfo.twitter_handle}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      id="twitterLink"
                    >
                      <Image className="socialButtonImages socialButtonLogo" src={Twitter01} />
                    </a>
                    {/* {this.props.instagramAccountInfo.showIconButtonNames &&
											<p className={`socialMediaName ${this.props.language === "ar" && "arabic"}`}>{translate[this.props.instagramAccountInfo.buttonTwitter]}</p>
										} */}
                  </Col>
                )}
                {this.props.instagramAccountInfo.googlemaplink && (
                  <Col className="columnDiv">
                    <a
                      href={
                        this.props.instagramAccountInfo.googlemaplink
                        // this.props.instagramAccountInfo.businessName === 'willcafe'
                        // 	? 'https://maps.app.goo.gl/q72cWJniwwvxGA5s9'
                        // 	: this.props.instagramAccountInfo.businessName === 'lampo'
                        // 	? 'https://goo.gl/maps/aegDT4rzUerq4Tkn9'
                        // 	: ''
                      }
                      target="_blank"
                      rel="noopener noreferrer"
                      id="googleMapLink"
                      className={"navLink"}
                    >
                      <Image className="socialButtonImages" src={Location01} />
                      {(this.props.instagramAccountInfo.showIconButtonNames || this.state.menuExpaned) &&
                        <p className={`socialMediaName ${this.props.language === "ar" && "arabic"}`}>{translate[this.props.instagramAccountInfo.buttonMap]}</p>
                      }
                    </a>
                    {/* {this.props.instagramAccountInfo.showIconButtonNames &&
											<p className={`socialMediaName ${this.props.language === "ar" && "arabic"}`}>{this.props.instagramAccountInfo.buttonMap}</p>
										} */}
                  </Col>
                )}
                {this.props.instagramAccountInfo.whatsappnumber && (
                  <Col className="columnDiv">
                    <a
                      // href={this.props.instagramAccountInfo.whatsappLink}
                      target="_blank"
                      rel="noopener noreferrer"
                      id="whatsappLink"
                      onClick={() => {
                        if (isMobile) {
                          window.open(`whatsapp://send?phone=${this.props.instagramAccountInfo.whatsappnumber}`)
                        } else {
                          window.open(this.props.instagramAccountInfo.whatsappLink)
                        }
                        return true
                      }}
                      className={"navLink"}
                    >
                      <Image className="socialButtonImages" src={WhatsApp01} />
                      {(this.props.instagramAccountInfo.showIconButtonNames || this.state.menuExpaned) &&
                        <p className={`socialMediaName ${this.props.language === "ar" && "arabic"}`}>{translate[this.props.instagramAccountInfo.buttonWhatsapp]}</p>
                      }
                    </a>
                    {/* {this.props.instagramAccountInfo.showIconButtonNames &&
											<p className={`socialMediaName ${this.props.language === "ar" && "arabic"}`}>{translate[this.props.instagramAccountInfo.buttonWhatsapp]}</p>
										} */}

                  </Col>
                )}
                {this.props.instagramAccountInfo.businessName === "bonabeel" && (
                  <Col className="columnDiv">
                    <a
                      href={"https://bonabeel.co/"}
                      target="_blank"
                      rel="noopener noreferrer"
                      id="websiteLink"

                    >
                      <Image className="socialButtonImages socialButtonLogo websiteLogo" src={Website} />
                    </a>
                    {/* {this.props.instagramAccountInfo.showIconButtonNames &&
											<p className="socialMediaName arabic bonabeelRegText">الإشتراك بالدورة</p>
										} */}

                  </Col>
                )}

              </Navbar.Collapse>
            </Animated>
          }
          <div className={"myCartBtn"}
            onClick={() => {
              this.setState({
                bucketExpaned: true
              })
            }}>
            <Image className={"myCartIcon"} src={CartIcon} />
            <p className={"cartListLength"}>
              {this.props.cartList && this.props.cartList.length > 0 && this.props.cartList.length}
            </p>
          </div>


        </Navbar>
      </Container>

      <CartMenu
        currency={this.props.currency}
        translate={this.props.translate}
        cartList={this.props.cartList}
        closeCartMenu={this.closeCartMenu}
        bucketExpaned={this.state.bucketExpaned}
      />
      <div className={"paymentStatusOuterDiv"}>
        <Image src={SuccessPurple} />

        <div className={"paymentStatusInnerDiv"}>
          <h3 className={"paymentStatusHeadMessage"}>
            SUCCESS!
          </h3>
          <p className={"paymentStatusSubMessage"}>
            Your payment was successful
          </p>
        </div>
      </div>
      <div className={"paymentCart"}>


        <div className={"bucketListScrollView paymentBucketList"} >
          {cartList && cartList.length === 0 &&
            <p className={"emptyCartText"}>
              {translate['Hey, it feels so light']}
              <p className={"emptyCartText emptyCartSubText"}>
                {translate['There is nothing in your cart']}
              </p>
            </p>}
          {
            cartList && cartList.map(data => {

              return (<div className={"bucketRow"} key={data.id}>
                <Image src={data.media_url} />
                <p className={"qtyP"}>{data.quantity}x</p>
                <div className={"bucketInnerDiv"}>
                  <div className={"firstRow"}>
                    <p className="prodName">
                      {data.name}
                    </p>
                    <p className={"priceBox"}>
                      <span>{currency}</span> {data.price}
                    </p>
                  </div>
                </div>
              </div>)
            })
          }
        </div>
      </div>
      <div className={"totalPriceOuterView"}>
        <div className={"totalPriceView"}>
          <h5 className={"totalPriceText"}>
            {"Total :"}
          </h5>
          <h5 className={"totalPriceAmountText"}>
            <span>{"KWD"}</span>
            {2300}
          </h5>
        </div>
      </div>
      <div className={"transactionDetailOutView"}>
        <div className={"transactionDetailSubView"}>
          <h5 className={"transactionDetailSubViewHeading"}>
            Credit Card
          </h5>
          <p className={"transactionDetailSubViewDesc"}>
            XXXX XXXX XXXX 1234
          </p>
        </div>
        <div className={"transactionDetailSubView"}>
          <h5 className={"transactionDetailSubViewHeading"}>
            Transaction Id
          </h5>
          <p className={"transactionDetailSubViewDesc"}>
            ABCD1234
          </p>
        </div>

        <div className={"transactionDetailSubView"}>
          <p className={"transactionDate"}>10/08/2020</p>
        </div>
      </div>
      <div className={"proceedToPaymentBottomView homeEndButtonView"}>
        <button className={"checkoutButton"} onClick={() => { this.props.history.push("/clientwebsite2") }}>
          {'Home'}
        </button>
      </div>
    </div>
  }
}
const mapDispatchToProps = dispatch => ({
  myCartList: () => dispatch(actionCreators.myCartList()),
  removeProductFromMyCart: (product_id) => dispatch(actionCreators.removeProductFromMyCart(product_id)),
  addProductToMyCart: (product_id) => dispatch(actionCreators.addProductToMyCart(product_id)),
  reduceProductQuantity: (product_id) => dispatch(actionCreators.reduceProductQuantity(product_id))
});
const mapStateToProps = state => ({

  pathname: state.login.pathname,
  translate: state.websiteLanguage.translations,
  featuredProductsList: state.campaign.featuredProductsList,
  popularProductsList: state.campaign.popularProductsList,
  explore_products: state.campaign.explore_products,
  currency: state.login.currency,
  cartList: state.cart.cartList,
  instagramAccountInfo: state.campaign.instagramAccountInfo
});
export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(PaymentEnd));



// WEBPACK FOOTER //
// ./src/pages/PaymentEnd.js